import { observer } from 'mobx-react-lite'
import { TableRow } from '@/components/Table'
import { type ScopeChangeRequestDetailsViewModel } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ScopeChangeRequestDetailsViewModel'
import { type ScopeChangePriceBreakDownItemForAdmin } from '@/features/admin/scope-change-requests/ScopeChangeRequest'
import { QuantityCell } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/QuantityCell'
import { ServiceCell } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/ServiceCell'
import { MoneyCellContainer } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/MoneyCell/MoneyCellContainer'
import { formatBundleAttribution } from '@/features/admin/scope-change-requests/scope-change-request-formatters'
import { ItemsBreakdownSection } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/ItemsBreakdownSection'

export interface InventoryItemsSectionContainerProps {
  vm: ScopeChangeRequestDetailsViewModel
}

export const InventoryItemsSectionContainer = observer(
  function InventoryItemsSectionContainer({
    vm,
  }: InventoryItemsSectionContainerProps) {
    return (
      <ItemsBreakdownSection
        title="Service items"
        itemColumnTitle="Service"
        isExpanded={vm.serviceItemsExpanded}
        onToggleExpanded={vm.toggleServiceItemsSection}
        count={
          vm.scopeChangeRequestPriceBreakDown.flatInventoryScopeChangeItems
            .length
        }
        showEditButton={vm.canEditItems}
        onEdit={vm.editInventoryItems}
      >
        {vm.scopeChangeRequestPriceBreakDown.flatInventoryScopeChangeItems.map(
          (item) => (
            <InventoryItemRowContainer
              editable={false}
              item={item}
              key={`${item.kind}-${item.inventoryItemVersionId}-${item.bundleId}`}
            />
          ),
        )}
      </ItemsBreakdownSection>
    )
  },
)

interface InventoryItemRowContainerProps {
  item: ScopeChangePriceBreakDownItemForAdmin
  editable: boolean
}

const InventoryItemRowContainer = observer(function InventoryItemRowContainer({
  item,
  editable,
}: InventoryItemRowContainerProps) {
  return (
    <TableRow>
      <QuantityCell>{item.quantityDiff}</QuantityCell>
      <ServiceCell detail={formatBundleAttribution(item)}>
        {item.name}
      </ServiceCell>
      <MoneyCellContainer
        editable={editable}
        model={item}
        testId="scope-change-request-item-price"
        field="priceDiff"
      >
        {item.priceDiff}
      </MoneyCellContainer>
      <MoneyCellContainer
        editable={editable}
        model={item}
        testId="scope-change-request-item-pro-price"
        field="proPriceDiff"
      >
        {item.proPriceDiff}
      </MoneyCellContainer>
    </TableRow>
  )
})
